"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const CardHeader_1 = __importDefault(require("@mui/material/CardHeader"));
const Card_1 = __importDefault(require("@mui/material/Card"));
const react_1 = __importDefault(require("react"));
const themes_1 = require("../../themes");
const Card = ({ color = 'default', variant = 'outlined', headerBackgroundColor = '#CDF7FF', headerContent = '', children, ...rest }) => {
    const theme = (0, themes_1.useTheme)();
    const backgroundColorMapping = {
        primary: theme.palette.primary.light,
        info: '#FBFDFE',
        error: '#FFDAD429',
        gray: theme.palette.grey[50],
        warn: theme.palette.warning.light,
        default: theme.palette.background.paper,
    };
    return (react_1.default.createElement(Card_1.default, { style: {
            backgroundColor: backgroundColorMapping[color] || theme.palette.background.paper,
            borderColor: variant === 'outlined' ? theme.palette.divider : undefined,
            border: variant !== 'outlined' ? 0 : undefined,
            borderRadius: 12,
        }, elevation: variant === 'elevation' ? 1 : 0, variant: variant, ...rest },
        headerContent && (react_1.default.createElement(CardHeader_1.default, { style: {
                backgroundColor: headerBackgroundColor,
                paddingBottom: '1rem',
            }, subheader: headerContent, subheaderTypographyProps: {
                fontWeight: 600,
                color: 'text.primary',
            } })),
        children));
};
exports.Card = Card;
exports.default = exports.Card;
